module.exports = __webpack_public_path__ + "img/LanceleauScreenshot1_1920x1080.c6c4b97f.png";